async function setMaxWidth(element, words) {
  await document.fonts.ready;

  let maxWidth = 0;
  const tempSpan = document.createElement('span');
  tempSpan.style.font = window.getComputedStyle(element).font;
  tempSpan.style.letterSpacing = '-2.56px';
  tempSpan.style.visibility = 'hidden';
  tempSpan.style.position = 'absolute';
  tempSpan.style.whiteSpace = 'nowrap';

  document.body.appendChild(tempSpan);

  words.forEach((word) => {
    tempSpan.textContent = word;
    maxWidth = Math.max(maxWidth, tempSpan.offsetWidth);
  });

  element.style.width = `${maxWidth}px`;
  document.body.removeChild(tempSpan);
}

function typeEffect() {
  // const screenWidthThreshold = 52 * 16 - 1;

  // if (window.innerWidth > screenWidthThreshold) {
  const changeTextElement = document.querySelector('.change-text');

  if (!changeTextElement) return;

  const words = changeTextElement.getAttribute('data-words').split(',');
  // setMaxWidth(changeTextElement, words);

  let currentWordIndex = 0;
  let letterIndex = 0;
  let isDeleting = false;

  function type() {
    if (isDeleting) {
      letterIndex--;
    } else {
      letterIndex++;
    }

    changeTextElement.textContent = words[currentWordIndex].substring(0, letterIndex);

    let typingSpeed = 200;
    if (isDeleting) typingSpeed /= 2;

    if (!isDeleting && letterIndex === words[currentWordIndex].length + 1) {
      typingSpeed = 1500;
      isDeleting = true;
    } else if (isDeleting && letterIndex === 0) {
      isDeleting = false;
      currentWordIndex = (currentWordIndex + 1) % words.length;
      typingSpeed = 500;
    }

    // switch (currentWordIndex) {
    //   case 0:
    //     changeTextElement.style.letterSpacing = '0px';
    //     break;
    //   case 1:
    //     changeTextElement.style.letterSpacing = null;
    //     break;
    //   case 2:
    //     changeTextElement.style.letterSpacing = '8.8px';
    //     break;
    // }

    setTimeout(type, typingSpeed);
  }

  type();
  // }
}

function fadeEffect() {
  const changeTextElement = document.querySelector('.change-text');

  const styles = window.getComputedStyle(document.querySelector('.text-hero'));
  const animationDuration = styles.getPropertyValue('--_animation-duration').trim();

  if (!changeTextElement) return;

  const words = changeTextElement.getAttribute('data-words').split(',');
  let currentWordIndex = 0;

  function changeWord() {
    changeTextElement.parentElement.style.opacity = 0;

    setTimeout(() => {
      changeTextElement.textContent = words[currentWordIndex];
      changeTextElement.parentElement.style.opacity = 1;

      currentWordIndex = (currentWordIndex + 1) % words.length;
    }, animationDuration); // Wait for the fade out to complete before changing the text
  }

  const intervalDuration = words.length * animationDuration;

  setInterval(changeWord, intervalDuration);
  changeWord();
}

// typeEffect();
fadeEffect();

// window.addEventListener('resize', () => {
// const changeTextElement = document.querySelector('.change-text');
// if (changeTextElement) {
// const words = changeTextElement.getAttribute('data-words').split(',');
// setMaxWidth(changeTextElement, words);
// }
// });
